import { Form as BaseForm, Input } from 'antd';
import Label from '../../components/label';
import Button from '../../components/button';
import Form from './form';
import { Paragraph } from '../../components/typography';
import ResourceSelect from '../../components/resource-select';

function ReportErrorForm({ resource }) {

  return (
    <Form name="ReportErrorForm" type="report_error" hiddenData={!!resource ? { errorSource: resource } : undefined}>
      {!!resource &&
        <Paragraph>
          Report an issue for the <strong>{resource.label} {resource.type}</strong>
        </Paragraph>
      }

      <Label text="Name" required labelFor="ReportErrorForm_data_name" />
      <BaseForm.Item
        name={["data", "name"]}
        rules={[{ required: true, message: "'Name' is required!" }]}
      >
        <Input aria-labelledby="ReportErrorForm_data_name_label" aria-required />
      </BaseForm.Item>

      <Label text="Email" required labelFor="ReportErrorForm_data_email" />
      <BaseForm.Item
        name={["data", "email"]}
        rules={[
          { required: true, message: "'Email' is required!" },
          { type: "email", message: "Provide a valid email address!" },
        ]}
      >
        <Input aria-labelledby="ReportErrorForm_data_email_label" aria-required />
      </BaseForm.Item>

      {!resource &&
        <>
          <Label required text="Material you would like to report an error for" labelFor="ReportErrorForm_data_errorSource" />
          <BaseForm.Item
            name={["data", "errorSource"]}
            rules={[
              { required: true, message: "Select a material" }
            ]}
          >
            <ResourceSelect aria-labelledby="ReportErrorForm_data_errorSource_label" aria-required />
          </BaseForm.Item>
        </>
      }

      <Label labelFor="ReportErrorForm_data_errorLocation"
        text="Where did you find the error?"
        description="For example, what chapter, page, material, or part of the video?"
      />
      <BaseForm.Item
        name={["data", "errorLocation"]}
      >
        <Input aria-labelledby="ReportErrorForm_data_errorLocation_label" />
      </BaseForm.Item>

      <Label required labelFor="ReportErrorForm_data_errorDescription"
        text="What did you find and how should we fix it?"
      />
      <BaseForm.Item
        name={["data", "errorDescription"]}
        rules={[{ required: true, message: "'Error description' is required!" }]}
      >
        <Input.TextArea aria-labelledby="ReportErrorForm_data_errorDescription_label" aria-required style={{ minHeight: "6em" }} autoSize />
      </BaseForm.Item>

      <Button htmlType="submit">Submit</Button>
    </Form>
  );
}

export default ReportErrorForm;
